var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconPlain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 6.8791665 6.8791666",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      strokeWidth: 0.264583
    },
    d: "M 2.9104166,0 H 3.96875 L 4.4979166,0.52916666 H 6.3499999 V 1.3229166 H 0.52916666 V 0.52916666 H 2.38125 Z",
    id: "path2552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2712",
    style: {
      fill: "#cfcfcf",
      strokeWidth: 0.264583
    },
    d: "M 1.3229166 1.5875 L 1.3229166 6.3499999 L 1.8520833 6.8791665 L 5.0270832 6.8791665 L 5.5562499 6.3499999 L 5.5562499 1.5875 L 1.3229166 1.5875 z M 2.38125 2.38125 L 2.6458333 2.6458333 L 2.6458333 5.8208332 L 2.38125 6.0854166 L 2.1166666 5.8208332 L 2.1166666 2.6458333 L 2.38125 2.38125 z M 3.4395833 2.38125 L 3.7041666 2.6458333 L 3.7041666 5.8208332 L 3.4395833 6.0854166 L 3.1749999 5.8208332 L 3.1749999 2.6458333 L 3.4395833 2.38125 z M 4.4979166 2.38125 L 4.7624999 2.6458333 L 4.7624999 5.8208332 L 4.4979166 6.0854166 L 4.2333333 5.8208332 L 4.2333333 2.6458333 L 4.4979166 2.38125 z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconPlain);
export default __webpack_public_path__ + "static/media/trash_icon_plain.8329ff72f2d5ef4514f709963030c0e4.svg";
export { ForwardRef as ReactComponent };